import React, { useState } from "react";
import AdminLayout from "../../layouts/AdminLayout";
import {
    SearchInput,
    StatCard,
    PageHeader,
    StatusBadge,
} from "./components";

function CustomerManagement() {
    // Örnek müşteri ve kiralama verileri
    const [customers, setCustomers] = useState([
        {
            id: "CUS001",
            name: "Ahmet Yılmaz",
            email: "ahmet@example.com",
            phone: "+90 532 123 4567",
            totalRentals: 3,
            totalSpent: "€12,450",
            lastRental: "10-10-2023",
            status: "Aktif",
            avatar: "AY",
            rentals: [
                {
                    id: "RNT001",
                    yachtName: "Azimut 55",
                    captain: "Mehmet Yılmaz",
                    startDate: "15-06-2023",
                    endDate: "20-06-2023",
                    duration: "5 gün",
                    route: "Girne - Gazimağusa",
                    amount: "€4,500",
                    status: "Tamamlandı",
                },
                {
                    id: "RNT005",
                    yachtName: "Princess 62",
                    captain: "Ayşe Demir",
                    startDate: "10-07-2023",
                    endDate: "15-07-2023",
                    duration: "5 gün",
                    route: "Girne - Lefke",
                    amount: "€3,800",
                    status: "Tamamlandı",
                },
                {
                    id: "RNT009",
                    yachtName: "Sunseeker 75",
                    captain: "Ali Kaya",
                    startDate: "05-08-2023",
                    endDate: "12-08-2023",
                    duration: "7 gün",
                    route: "Girne - Baf",
                    amount: "€4,150",
                    status: "Tamamlandı",
                },
            ],
        },
        {
            id: "CUS002",
            name: "Zeynep Kaya",
            email: "zeynep@example.com",
            phone: "+90 533 456 7890",
            totalRentals: 2,
            totalSpent: "€9,200",
            lastRental: "25-09-2023",
            status: "Aktif",
            avatar: "ZK",
            rentals: [
                {
                    id: "RNT003",
                    yachtName: "Sunseeker 75",
                    captain: "Ali Kaya",
                    startDate: "25-06-2023",
                    endDate: "02-07-2023",
                    duration: "7 gün",
                    route: "Girne - Limasol",
                    amount: "€5,200",
                    status: "Tamamlandı",
                },
                {
                    id: "RNT007",
                    yachtName: "Azimut 55",
                    captain: "Mehmet Yılmaz",
                    startDate: "20-09-2023",
                    endDate: "25-09-2023",
                    duration: "5 gün",
                    route: "Girne - Larnaka",
                    amount: "€4,000",
                    status: "Tamamlandı",
                },
            ],
        },
        {
            id: "CUS003",
            name: "Mehmet Demir",
            email: "mehmet@example.com",
            phone: "+90 535 789 0123",
            totalRentals: 1,
            totalSpent: "€6,500",
            lastRental: "15-08-2023",
            status: "Aktif",
            avatar: "MD",
            rentals: [
                {
                    id: "RNT006",
                    yachtName: "Princess 62",
                    captain: "Ayşe Demir",
                    startDate: "15-08-2023",
                    endDate: "22-08-2023",
                    duration: "7 gün",
                    route: "Girne - Baf - Limasol",
                    amount: "€6,500",
                    status: "Tamamlandı",
                },
            ],
        },
        {
            id: "CUS004",
            name: "Ayşe Yıldız",
            email: "ayse@example.com",
            phone: "+90 536 234 5678",
            totalRentals: 2,
            totalSpent: "€7,800",
            lastRental: "05-10-2023",
            status: "Aktif",
            avatar: "AY",
            rentals: [
                {
                    id: "RNT002",
                    yachtName: "Princess 62",
                    captain: "Ayşe Demir",
                    startDate: "20-06-2023",
                    endDate: "25-06-2023",
                    duration: "5 gün",
                    route: "Girne - Lefkoşa",
                    amount: "€3,800",
                    status: "Tamamlandı",
                },
                {
                    id: "RNT008",
                    yachtName: "Sunseeker 75",
                    captain: "Ali Kaya",
                    startDate: "01-10-2023",
                    endDate: "05-10-2023",
                    duration: "4 gün",
                    route: "Girne - Gazimağusa",
                    amount: "€4,000",
                    status: "Tamamlandı",
                },
            ],
        },
    ]);

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    // Müşteri detaylarını göster/gizle
    const toggleCustomerDetails = (customerId) => {
        if (selectedCustomer === customerId) {
            setSelectedCustomer(null);
        } else {
            setSelectedCustomer(customerId);
        }
    };

    // Arama fonksiyonu
    const filteredCustomers = customers.filter(
        (customer) =>
            customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            customer.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            customer.phone.includes(searchTerm)
    );

    // Toplam istatistikler
    const totalCustomers = customers.length;
    const totalRentals = customers.reduce(
        (total, customer) => total + customer.totalRentals,
        0
    );
    const totalRevenue =
        "€" +
        customers
            .reduce((total, customer) => {
                const amount = parseFloat(
                    customer.totalSpent.replace("€", "").replace(",", "")
                );
                return total + amount;
            }, 0)
            .toLocaleString();

    return (
        <AdminLayout currentPage="customers">
                    <PageHeader
                        title="Müşteri Yönetimi"
                        subtitle={`Toplam ${totalCustomers} müşteri, ${totalRentals} kiralama`}
                    >
                        <SearchInput
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Müşteri ara..."
                        />
                        <button className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors flex items-center gap-2">
                            <svg
                                className="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 4v16m8-8H4"
                                />
                            </svg>
                            Yeni Müşteri
                        </button>
                    </PageHeader>

                    {/* İstatistik Kartları */}
                    <div className="grid grid-cols-3 gap-6 mb-8">
                        <StatCard
                            title="Toplam Müşteri"
                            value={totalCustomers}
                            subtitle="Son 30 günde 5 yeni müşteri"
                        />

                        <StatCard
                            title="Toplam Kiralama"
                            value={totalRentals}
                            subtitle="Son 30 günde 8 kiralama"
                        />

                        <StatCard
                            title="Toplam Gelir"
                            value={totalRevenue}
                            subtitle="Son 30 günde €15,800"
                        />
                    </div>

                    {/* Müşteri Listesi */}
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 mb-8">
                        <h2 className="text-xl font-bold mb-6">
                            Müşteri Listesi
                        </h2>

                        <div className="space-y-4">
                            {filteredCustomers.map((customer) => (
                                <div
                                    key={customer.id}
                                    className="border border-white/10 rounded-xl overflow-hidden"
                                >
                                    {/* Müşteri Başlık Satırı */}
                                    <div
                                        className="flex items-center justify-between p-4 cursor-pointer hover:bg-white/5 transition-colors"
                                        onClick={() =>
                                            toggleCustomerDetails(customer.id)
                                        }
                                    >
                                        <div className="flex items-center gap-4">
                                            <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                                                {customer.avatar}
                                            </div>
                                            <div>
                                                <h3 className="font-medium">
                                                    {customer.name}
                                                </h3>
                                                <p className="text-white/60 text-sm">
                                                    {customer.email} •{" "}
                                                    {customer.phone}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-6">
                                            <div className="text-right">
                                                <p className="text-white/60 text-sm">
                                                    Toplam Kiralama
                                                </p>
                                                <p className="font-medium">
                                                    {customer.totalRentals}
                                                </p>
                                            </div>
                                            <div className="text-right">
                                                <p className="text-white/60 text-sm">
                                                    Toplam Harcama
                                                </p>
                                                <p className="font-medium">
                                                    {customer.totalSpent}
                                                </p>
                                            </div>
                                            <div className="text-right">
                                                <p className="text-white/60 text-sm">
                                                    Son Kiralama
                                                </p>
                                                <p className="font-medium">
                                                    {customer.lastRental}
                                                </p>
                                            </div>
                                            <div>
                                                <span className="px-2 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">
                                                    {customer.status}
                                                </span>
                                            </div>
                                            <div>
                                                <svg
                                                    className={`w-5 h-5 text-white/60 transition-transform duration-300 ${
                                                        selectedCustomer ===
                                                        customer.id
                                                            ? "rotate-180"
                                                            : ""
                                                    }`}
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M19 9l-7 7-7-7"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Müşteri Detayları (Açılır Kapanır) */}
                                    {selectedCustomer === customer.id && (
                                        <div className="p-4 bg-white/5 border-t border-white/10">
                                            <h4 className="font-medium mb-4">
                                                Kiralama Geçmişi
                                            </h4>
                                            <div className="overflow-x-auto">
                                                <table className="w-full">
                                                    <thead>
                                                        <tr className="text-white/60 border-b border-white/10">
                                                            <th className="text-left pb-3 font-medium">
                                                                ID
                                                            </th>
                                                            <th className="text-left pb-3 font-medium">
                                                                Yat
                                                            </th>
                                                            <th className="text-left pb-3 font-medium">
                                                                Kaptan
                                                            </th>
                                                            <th className="text-left pb-3 font-medium">
                                                                Başlangıç
                                                            </th>
                                                            <th className="text-left pb-3 font-medium">
                                                                Bitiş
                                                            </th>
                                                            <th className="text-left pb-3 font-medium">
                                                                Süre
                                                            </th>
                                                            <th className="text-left pb-3 font-medium">
                                                                Rota
                                                            </th>
                                                            <th className="text-left pb-3 font-medium">
                                                                Tutar
                                                            </th>
                                                            <th className="text-left pb-3 font-medium">
                                                                Durum
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {customer.rentals.map(
                                                            (rental) => (
                                                                <tr
                                                                    key={
                                                                        rental.id
                                                                    }
                                                                    className="border-b border-white/5 hover:bg-white/5"
                                                                >
                                                                    <td className="py-3">
                                                                        {
                                                                            rental.id
                                                                        }
                                                                    </td>
                                                                    <td className="py-3">
                                                                        {
                                                                            rental.yachtName
                                                                        }
                                                                    </td>
                                                                    <td className="py-3">
                                                                        {
                                                                            rental.captain
                                                                        }
                                                                    </td>
                                                                    <td className="py-3">
                                                                        {
                                                                            rental.startDate
                                                                        }
                                                                    </td>
                                                                    <td className="py-3">
                                                                        {
                                                                            rental.endDate
                                                                        }
                                                                    </td>
                                                                    <td className="py-3">
                                                                        {
                                                                            rental.duration
                                                                        }
                                                                    </td>
                                                                    <td className="py-3">
                                                                        {
                                                                            rental.route
                                                                        }
                                                                    </td>
                                                                    <td className="py-3">
                                                                        {
                                                                            rental.amount
                                                                        }
                                                                    </td>
                                                                    <td className="py-3">
                                                                        <span className="px-2 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">
                                                                            {
                                                                                rental.status
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
        </AdminLayout>
    );
}

export default CustomerManagement;
